var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTemplateRu = function SvgUserTemplateRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "currentColor",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45996 12.1707V4.9707H11.06V12.0707H9.55996V6.2707H6.95996V12.1707H5.45996Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 2.57031V14.5703H2.25977V2.57031H14.2598ZM15.2598 1.57031H1.25977V15.5703H15.2598V1.57031Z"
  })));
};
export default SvgUserTemplateRu;